module.exports = __webpack_public_path__ + "static/img/RICKY_PONTING.1c185dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/RICKY_PONTING.jpg
// module id = BqpR
// module chunks = 0